export default function FeaturedToggle({
  brandTitle,
  isFeatured,
  disabled,
  isUpdating,
  onToggle,
}) {
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        role="switch"
        aria-checked={isFeatured}
        aria-label={`Set ${brandTitle || "brand"} ${
          isFeatured ? "not featured" : "featured"
        }`}
        disabled={disabled}
        onClick={onToggle}
        className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
          isFeatured ? "bg-cyan-500" : "bg-gray-200"
        }`}
      >
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
            isFeatured ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </button>
    </div>
  );
}